import React, { useEffect, useRef, useState } from "react";
import { Arrow, Calendar, DayTile, DaysDiv, InputContainer, MonthHeader, WeekdayTile, } from "./styles";
import { addMonths, compareAsc, eachDayOfInterval, endOfDay, endOfMonth, startOfMonth, subMonths, } from "date-fns";
import { TiArrowSortedDown } from "react-icons/ti";
import { weekdays, months } from "../../../utils/constants";
import { fillDaysArray, formatDateToString, hexToRgb, } from "../../../utils/functions";
export var DayCalendar = function (_a) {
    var value = _a.value, onDateSelected = _a.onDateSelected, calendarColor = _a.calendarColor;
    var now = new Date();
    var customColor = calendarColor ? calendarColor : "#ff2c3a";
    var hoverCustomColor = hexToRgb(customColor).hover;
    var calendarRef = useRef();
    var _b = useState(0), leftDistance = _b[0], setLeftDistance = _b[1];
    var _c = useState(false), showCalendar = _c[0], setShowCalendar = _c[1];
    var _d = useState(value), daySelected = _d[0], setDaySelected = _d[1];
    var _e = useState({
        start: startOfMonth(now),
        end: endOfMonth(now)
    }), monthToShow = _e[0], setMonthToShow = _e[1];
    var _f = useState([]), daysToShow = _f[0], setDaysToShow = _f[1];
    useEffect(function () {
        onDateSelected && onDateSelected(daySelected);
    }, [daySelected]);
    useEffect(function () {
        var daysOfTheMonth = eachDayOfInterval(monthToShow);
        fillDaysArray(daysOfTheMonth);
        setDaysToShow(daysOfTheMonth.map(function (day) {
            return {
                value: day,
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear(),
                weekday: day.getDay()
            };
        }));
    }, [monthToShow]);
    useEffect(function () {
        window.addEventListener("click", function () {
            setShowCalendar(false);
        });
    }, []);
    useEffect(function () {
        if (calendarRef.current) {
            setLeftDistance(calendarRef.current.getBoundingClientRect().left);
        }
    }, [calendarRef]);
    return (React.createElement("div", { ref: calendarRef, style: {
            position: "relative",
            width: "fit-content"
        }, onClick: function (e) { return e.stopPropagation(); } },
        React.createElement(Arrow, { show: showCalendar }),
        React.createElement(InputContainer, { customColor: customColor, onClick: function () { return setShowCalendar(!showCalendar); } },
            React.createElement("p", null,
                daySelected.start ? formatDateToString(daySelected.start) : "",
                " "),
            React.createElement(TiArrowSortedDown, { color: customColor, size: 25 })),
        React.createElement(Calendar, { show: showCalendar, leftDistance: leftDistance },
            React.createElement("div", null,
                React.createElement(MonthHeader, { customColor: customColor },
                    React.createElement("div", null),
                    React.createElement("span", null, monthToShow.start.getFullYear()),
                    React.createElement("div", null)),
                React.createElement(MonthHeader, { customColor: customColor, style: { borderRadius: 0 } },
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: subMonths(monthToShow.start, 1),
                                end: subMonths(monthToShow.end, 1)
                            });
                        }, color: customColor, size: 25, style: {
                            transform: "rotate(90deg)"
                        } }),
                    React.createElement("span", null, months[monthToShow.start.getMonth()]),
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: addMonths(monthToShow.start, 1),
                                end: addMonths(monthToShow.end, 1)
                            });
                        }, color: customColor, size: 25, style: {
                            transform: "rotate(-90deg)"
                        } })),
                React.createElement(DaysDiv, null,
                    weekdays.map(function (wd, i) { return (React.createElement(WeekdayTile, { idx: i }, wd)); }),
                    daysToShow.map(function (day, i) {
                        return (React.createElement(DayTile, { key: i, day: day, customColor: customColor, hoverCustomColor: hoverCustomColor, isThisMonth: day.month !== monthToShow.start.getMonth(), isSelected: daySelected.start
                                ? compareAsc(daySelected.start, day.value) === 0
                                : false, onClick: function () {
                                setDaySelected({
                                    start: day.value,
                                    end: endOfDay(day.value)
                                });
                                setShowCalendar(false);
                            } }, day.day));
                    }))))));
};
//# sourceMappingURL=index.js.map